module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Ga-Hc-Ic-Ja.3d35f12c.png";